import React, { useState, useEffect,useRef } from "react";
import { useLocation } from "react-router-dom";

import {
  Container,
  Typography,
  Card,
  CardContent,
  CardMedia,
  CardActions,
  IconButton,
  Grid,
  Stack,
  Box,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import axios from "axios";
//import BASE_URL from "../config";
import BASE_URL from "../config";
const VideoPage = () => {
  const [events, setEvents] = useState([]);
  const [currentVideoIndexes, setCurrentVideoIndexes] = useState({});
  const location = useLocation();
  const eventRefs = useRef({});
  const [isEventsLoaded, setIsEventsLoaded] = useState(false);
  //const [filteredEvent, setFilteredEvent] = useState(null);

  useEffect(() => {
    fetchEvents();
    setIsEventsLoaded(true);
  }, []);
  useEffect(() => {
    let eventId;
  if (location.search) {
    const searchParams = new URLSearchParams(location.search);
    eventId = searchParams.get("event_id");
  } else if (location.pathname) {
    eventId = location.pathname.split("/").pop();
  }

  if (isEventsLoaded && eventId) {
    const eventElement = eventRefs.current[eventId];
    if (eventElement) {
      eventElement.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }
}, [isEventsLoaded, location]);
   /*  if (eventId && eventRefs.current[eventId]) {
      eventRefs.current[eventId].scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [events]); */
  const fetchEvents = async () => {
    const response = await axios.get(`${BASE_URL}/api/events`);
    setEvents(response.data);
    const initialIndexes = response.data.reduce(
      (acc, event) => ({ ...acc, [event.event_id]: 0 }),
      {}
    );
    setCurrentVideoIndexes(initialIndexes);
  };

  const handleVideoNavigation = (eventId, direction) => {
    setCurrentVideoIndexes((prevIndexes) => {
      const currentIndex = prevIndexes[eventId];
      const videoCount = events.find((event) => event.event_id === eventId).videos.length;

      if (direction === "next" && currentIndex < videoCount - 1) {
        return { ...prevIndexes, [eventId]: currentIndex + 1 };
      } else if (direction === "prev" && currentIndex > 0) {
        return { ...prevIndexes, [eventId]: currentIndex - 1 };
      }
      return prevIndexes;
    });
  };

  return (
    <Container sx={{ mt: 4 }}>
      <Typography variant="h4" align="center" gutterBottom>
        Event Videos
      </Typography>
      <Grid container spacing={3}>
        {events.map((event) => (
          <Grid item xs={12} sm={6} md={3} key={event.event_id}
          ref={(el) => (eventRefs.current[event.event_id] = el)}
          >
            <Card
              sx={{
                boxShadow: 3,
                transition: "transform 0.2s ease-in-out",
                "&:hover": { transform: "scale(1.05)" },
                display: "flex",
                flexDirection: "column", // Ensure vertical stacking
                border: (location.search.includes(`event_id=${event.event_id}`) || location.pathname.endsWith(`/${event.event_id}`))
                ? "2px solid #FF6B6B" // Highlight border for selected event
                : "none",
                padding: 0, // Remove padding
              }}
            >
              <CardContent
  sx={{
    background: "linear-gradient(45deg, #FF6B6B, #FFD93D)",
    //borderRadius: "8px",
    padding: "8px",
    //boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    //marginBottom: "0", // Ensure no margin below CardContent
    "&:last-child": {
      paddingBottom: "8px", // Remove extra bottom padding
    },

  }}
>
  <Typography
    variant="h6"
    align="center"
    gutterBottom
    sx={{
      fontWeight: "bold",
      color: "white",
      textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)",
      //fontFamily: "Roboto, sans-serif",
    }}
  >
    {event.event_name}
  </Typography>
</CardContent>
              <Box
                sx={{
                  mt: 0, // Removes any top margin
                  p: 0, // Removes padding
                }}
              
              >
                {event.videos.length > 0 ? (
                  <CardMedia
                    component="video"
                    src={`${BASE_URL}/uploads/videos/${event.event_id}/${event.videos[currentVideoIndexes[event.event_id]]}`}
                    controls
                    sx={{
                      height: { xs: "200px", md: "250px" },
                      width: "100%",
                      margin: 0, // Remove any margin around the media

                      //borderTop: "1px solid #ddd", // Optional: subtle border for separation
                    }}
                  />
                ) : (
                  <Typography align="center">No videos available</Typography>
                )}
              </Box>
              {event.videos.length > 0 && (
                <CardActions>
                  <Stack
                    direction="row"
                    spacing={1}
                    justifyContent="center"
                    sx={{ width: "100%" }}
                  >
                    <IconButton
                      onClick={() => handleVideoNavigation(event.event_id, "prev")}
                      disabled={currentVideoIndexes[event.event_id] === 0}
                    >
                      <ArrowBackIosIcon />
                    </IconButton>
                    <IconButton
                      onClick={() => handleVideoNavigation(event.event_id, "next")}
                      disabled={
                        currentVideoIndexes[event.event_id] ===
                        event.videos.length - 1
                      }
                    >
                      <ArrowForwardIosIcon />
                    </IconButton>
                  </Stack>
                </CardActions>
              )}
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default VideoPage;
